(function () {
  'use strict';

  // Desktop site navigation. Event delegation also supports Shopify theme editor re-renders.
  if (window.__stpV2DropdownsReady) return;
  window.__stpV2DropdownsReady = true;

  var selector = '.stp-v2-home-nav > li > details';

  function allDropdowns() {
    return document.querySelectorAll(selector);
  }

  function closeDropdowns(except) {
    allDropdowns().forEach(function (dropdown) {
      if (dropdown !== except && dropdown.open) dropdown.open = false;
    });
  }

  // Opening any dropdown closes previously opened siblings.
  document.addEventListener('toggle', function (event) {
    var dropdown = event.target;
    if (!(dropdown instanceof HTMLDetailsElement) || !dropdown.matches(selector) || !dropdown.open) return;
    closeDropdowns(dropdown);
  }, true);

  // A click/tap elsewhere on the page dismisses the menu.
  document.addEventListener('pointerdown', function (event) {
    var target = event.target;
    if (!(target instanceof Element) || !target.closest('.stp-v2-home-nav')) closeDropdowns();
  }, true);

  // Also dismiss when following a menu link (including same-page anchors).
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (target instanceof Element && target.closest('.stp-v2-home-nav a')) closeDropdowns();
  });

  // Manufacturer shortcuts link directly to filtered collections; retain preview context only for unpublished themes.
  // While testing an unpublished theme, keep the user in the same theme preview.
  document.addEventListener('click', function (event) {
    var element = event.target;
    if (!(element instanceof Element)) return;
    var link = element.closest('.stp-v2-home-nav a[data-stp-nav-manufacturer]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (!preview && window.Shopify && window.Shopify.theme && String(window.Shopify.theme.role || '').toLowerCase() !== 'main') {
      var themeId = String(window.Shopify.theme.id || '');
      if (/^\d{6,20}$/.test(themeId)) preview = themeId;
    }
    if (!preview || !/^\d{6,20}$/.test(preview)) return;
    var target = new URL(link.href, window.location.origin);
    target.searchParams.set('preview_theme_id', preview);
    event.preventDefault();
    window.location.assign(target.pathname + target.search + target.hash);
  }, true);

  // Escape closes the dropdown and returns keyboard focus to its trigger.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var current = Array.from(allDropdowns()).find(function (dropdown) { return dropdown.open; });
    if (!current) return;
    closeDropdowns();
    event.preventDefault();
    var summary = current.querySelector(':scope > summary');
    if (summary) summary.focus();
  }, true);

  // Prevent stale open menus when a browser restores the page from history.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) closeDropdowns();
  });
})();
